import React from 'react';
import PropTypes from 'prop-types';
import css from './SuggestedUses.module.css';

const SuggestedUses = ({ uses }) => {
  if (!uses || uses.length === 0) return null;

  const mid = Math.ceil(uses.length / 2);
  const col1 = uses.slice(0, mid);
  const col2 = uses.slice(mid);

  return (
    <section className={css.panel} aria-labelledby="suggested-uses-heading">
      <h2 id="suggested-uses-heading" className={css.heading}>
        Suggested Uses for This Item
      </h2>
      <div className={css.grid} role="list">
        <ul className={css.column}>
          {col1.map((use, i) => (
            <li key={i}>
              <span className={css.icon}>
                <i
                  style={{ fontSize: 23, color: '#F2704E' }}
                  className="ri-checkbox-circle-fill"
                  aria-hidden="true"
                ></i>
              </span>
              <span>{use}</span>
            </li>
          ))}
        </ul>
        <ul className={css.column}>
          {col2.map((use, i) => (
            <li key={i}>
              <span className={css.icon}>
                <i
                  style={{ fontSize: 23, color: '#F2704E' }}
                  className="ri-checkbox-circle-fill"
                  aria-hidden="true"
                ></i>
              </span>
              <span>{use}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

SuggestedUses.propTypes = {
  uses: PropTypes.arrayOf(PropTypes.string),
};

export default SuggestedUses;
